import { AccountIcon } from '../Brand/Icon';
import React, { useLayoutEffect, useRef, useState } from "react";
import { AccountPhoto } from '../ContentImage';
import { accountPhotoUrl } from '../../utils/accountPhoto';
import './index.scss';

function AvatarImage({ picture, loading, pending, containerRef, onError }) {
    const [status, setStatus] = useState(picture || pending ? 'loading' : 'empty');
    const image = useRef(null);

    useLayoutEffect(() => {
        // Route navigation remounts the footer. A cached avatar is already
        // available before load is delivered: show it before the first paint.
        if (image.current?.complete && image.current.naturalWidth > 0) setStatus('loaded');
    }, []);

    return (
        <span ref={containerRef} className="avatar-image nav-icon" data-status={status} aria-hidden="true">
            <AccountIcon className="userImage avatar-image__fallback" />
            {picture && status !== 'error' && <img
                ref={image}
                loading={loading}
                className="roundImage userImage avatar-image__photo"
                src={picture}
                alt=""
                onLoad={() => setStatus('loaded')}
                onError={() => { setStatus('error'); onError?.(); }}
            />}
        </span>
    );
}

function UserPicture({ picture, loading }) {
    const [authorize, setAuthorize] = useState(false);
    const source = accountPhotoUrl(picture);
    // Keep the cached public-avatar path, including its first-paint behavior.
    // An owner may also preview a non-public avatar while their account is
    // under review. Only a failed managed URL needs the credentialed fallback.
    if (authorize && source) return <AccountPhoto source={source} loading={loading}
        renderImage={({ src, pending, containerRef }) => <AvatarImage key={src || String(pending)}
            picture={src} pending={pending} containerRef={containerRef} loading={loading} />} />;
    return <AvatarImage picture={picture} loading={loading} onError={source ? () => setAuthorize(true) : undefined} />;
}

export default function UserImage({ picture, loading = 'lazy' }) {
    // A different source starts with the same placeholder, even if the previous image failed.
    return <UserPicture key={picture || 'empty-avatar'} picture={picture} loading={loading} />;
}
